
<template>
  <el-dialog
    :title="dialogName"
    :visible.sync="dialogVisible"
    width="40%"
    @close="close"
  >
    <el-form ref="form" :model="form" :rules="rules" label-width="80px">
      <div style="display: flex">
        <el-form-item label="上传图片">
          <el-upload
            class="avatar-uploader"
            :action="URL + '/data/upload'"
            :show-file-list="false"
            :headers="{ Authorization: 'bearer' + token }"
            :on-success="handleAvatarSuccess"
          >
            <img v-if="form.typeImg" :src="form.typeImg" class="avatar" />
            <i
              v-else
              class="el-icon-plus avatar-uploader-icon"
              style="border: 1px solid; margin-left: 10px"
            ></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="上传说明书" label-width="100px">
          <el-upload
            class="avatar-uploader"
            :action="URL + '/data/upload'"
            :headers="{ Authorization: 'bearer' + token }"
            :on-success="handleManualSuccess"
            :limit="1"
            :on-preview="handlePreview"
            :on-remove="handleRemove"
            :before-upload="beforeAvatarUpload"
            accept=".pdf"
            :file-list="fileList"
          >
            <!-- <img v-if="form.instructionUrl" :src="form.instructionUrl" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon" style="border:1px solid ;margin-left:10px"></i> -->
            <!-- <li></li> -->
            <!-- <a :href="form.instructionUrl"></a> -->
            <i
              v-if="!form.instructionUrl"
              class="el-icon-plus avatar-uploader-icon"
              style="border: 1px solid; margin-left: 10px"
            ></i>
          </el-upload>
        </el-form-item>
      </div>

      <el-form-item label="品牌" prop="brandId">
        <el-select
          v-model="form.brandId"
          placeholder="请选择"
          @change="initCarModelType()"
          clearable
          style="width: 100%; display: inline-block"
        >
          <el-option
            v-for="item in options"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="型号" prop="type">
        <el-input v-model="form.type"></el-input>
      </el-form-item>
      <el-form-item label="车型" prop="carModel">
        <el-select
          v-model="form.carModel"
          placeholder="请选择"
          clearable
          style="width: 100%; display: inline-block"
        >
          <el-option
            v-for="item in modelOptions"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="bnt-bottom">
        <el-button type="primary" @click="validate('form')">保存</el-button>
        <el-button @click="close">取消</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>
<script>
import { addType, updateCarType } from '@/api/system'
import { GetDataSelectXing, queryDataModel } from '@/api/system'
import { getToken } from '@/utils/auth'
export default {
  data () {
    return {
      dialogVisible: true,
      dialogName: this.$parent.dialogName,
      token: getToken(),
      form: {
        carModel: '',
        typeImg: '',
        brandId: '',
        type: '',
        id: '',
        instructionUrl: ''
      },
      rules: {
        brandId: [
          { required: true, message: '请选择品牌', trigger: 'change' }
        ],
        type: [
          { required: true, message: '请输入型号', trigger: 'blur' }
        ],
        carModel: [
          { required: true, message: '请输入车型', trigger: 'blur' }
        ],
      },
      options: [],
      modelOptions: [],
      URL: process.env.VUE_APP_BASE_API,
      fileList: []
    }
  },
  mounted () {
    //this.options = this.$parent.options
    this.GetSelect()
    // this.initCarModelType()
    this.fileList = []
    if (this.$parent.childform.id) {
      this.form.id = this.$parent.childform.id
      this.form.brandId = this.$parent.childform.brandId
      this.form.type = this.$parent.childform.type
      this.form.typeImg = this.$parent.childform.typeImg
      this.form.carModel = this.isNotEmpty(this.$parent.childform.carModel) ? this.$parent.childform.carModel : null
      this.form.instructionUrl = this.$parent.childform.instructionUrl
      if (this.form.instructionUrl) {
        this.fileList = [{ name: '说明书', url: this.form.instructionUrl }]
      }
    }
  },
  methods: {
    beforeAvatarUpload (file) {
      // const isJPG = file.type === 'image/jpeg';
      const isLt100M = file.size / 1024 / 1024 < 100;

      // if (!isJPG) {
      //   this.$message.error('上传头像图片只能是 JPG 格式!');
      // }
      if (!isLt100M) {
        this.$message.error('上传文件大小不能超过 100MB!');
      }
      return isLt100M;
    },
    handlePreview (res) {
      // console.log(res)
      window.open(res.url)
    },
    handleRemove () {
      this.fileList = []
      this.form.instructionUrl = ''
    },
    handleAvatarSuccess (res) {
      if (res.code === 0) {
        this.form.typeImg = res.data.src
      }
    },
    handleManualSuccess (res) {
      if (res.code === 0) {
        this.form.instructionUrl = res.data.src
      }
    },
    //非空判断
    isNotEmpty (str) {
      if (str != null && str != '') {
        return true
      }
      return false
    },
    close () {
      this.$parent.dialogVisible = false
    },
    GetSelect () {
      GetDataSelectXing().then(res => {
        this.options = res.data.content
      })
    },
    validate (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.onSubmit()
        } else {
          return false
        }
      })
    },
    onSubmit () {
      if (this.form.id) {
        this.updateType()
        return
      }
      delete this.form.id
      addType(this.form).then(res => {
        if (res.code === 0) {
          this.$message.success('新增成功')
          this.close()
          this.$emit('refresh')
        }
      })
    },
    initCarModelType () {
      this.form.carModel = ''
      if (this.form.brandId) {
        queryDataModel({ brandId: this.form.brandId }).then(res => {
          console.log(res.data)
          this.modelOptions = res.data.content
        })
      } else {
        this.modelOptions = []
      }
    },
    updateType () {
      updateCarType(this.form).then(res => {
        if (res.code === 0) {
          this.$message.success('编辑成功')
          this.close()
          this.$emit('refresh')
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
/deep/.el-form {
  padding-right: 20px;
  margin-top: 30px;
}
.container {
  .bnt-bottom {
    /deep/ .el-form-item__content {
      width: 100%;
      text-align: center;
      margin-top: 10px;
      margin-left: 0 !important;
    }
  }
}
.avatar {
  .img {
    padding: 30px 10px;
    border: 1px solid #bbb;
  }
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>

